<div class="container">
    <agm-map #AgmMap 
    style="width: 100%; height: 100%;" 
    (mapReady)="onMapReady($event)" 
    [zoomControl]="true"
    [scrollwheel]="true"
    [streetViewControl]="false"
    [latitude]="41.2925" [longitude]="12.56738"
    [zoom]="5"> 
    <!-- <div *ngFor="let area of this.aree;">
    <agm-data-layer 
    (layerClick)="clicked($event)" 
    [style]="styleFunc"></agm-data-layer>
    </div>   -->
    </agm-map>
    <button mat-mini-fab color="warn" id="reset-button" (click)="resetDrawing()" [disabled]="overlays.length == 0">
        <mat-icon>clear</mat-icon>
      </button>
    <!-- <button mat-stroked-button id="save-button" class="action-button" (click)="saveDrawing()" color="primary">save</button> -->
</div>
